import { render, staticRenderFns } from "./ListagemCompraFiltros.vue?vue&type=template&id=61462aaa"
import script from "./ListagemCompraFiltros.vue?vue&type=script&lang=js"
export * from "./ListagemCompraFiltros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports